import React from 'react';
import { View } from 'react-native-web';

const KeyboardAwareScrollView = () => {
  return (
    <View>

    </View>
  )
}

export default KeyboardAwareScrollView;
